import * as firebase from 'firebase/app'
import _ from 'lodash'
import urlParse from 'url-parse';
import {tryCall, getThreeDecimals} from "../utils";
import runtime from "../utils/runtime";
import storage from "../utils/storage";
import { checkCompat } from '../compatibility';
import { getRouteName, getUrl } from '../utils/path';
import { getDeviceLevel } from '../utils/device';
import { transport } from '../transport';
import { FIREBASE_ENDPOINT_NAME, PROMETHEUS_ENDPOINT_NAME } from '../constants';

const TDigest = require('tdigest').TDigest;
const digest = new TDigest();

const timeList = []
const N = 100   //阀值

const SLOW_FLAG = 16 //ms
const FREEZE_FLAG = 700 //ms

const LOCAL_STORAGE_NAME = 'LOCAL_STORAGE_FRAME_11a7e25822'

let lastFrameTime = tryCall(() => performance.getEntriesByType('paint').find(i => i.name === "first-paint").startTime) || 0
let metrics

// 部分网上摘抄
// 直观感受，不同帧率的体验：
// - 帧率能够达到 50 ～ 60 FPS 的动画将会相当流畅，让人倍感舒适；
// - 帧率在 30 ～ 50 FPS 之间的动画，因各人敏感程度不同，舒适度因人而异；
// - 帧率在 30 FPS 以下的动画，让人感觉到明显的卡顿和不适感；
// - 帧率波动很大的动画，亦会使人感觉到卡顿。


//初始化进来
export function init() {
    tryCall(() => {
        if (!!performance.now) {
            loop(performance.now())
        }
    }, false)

    // 初始化检查数据
    checkLocalStorageData()

    //离开页面检查数据
    window.addEventListener("beforeunload", () => {
        writeFrameData();
    });
}

//路由变化进来
export function whenRouterChange() {
    // API 兼容性检查，不支持raf设备不采集数据
    if (!window.performance || !window.localStorage || !window.requestAnimationFrame) {
        return false
    }
    digest.reset();

    checkLocalStorageData()
}

export function writeFrameData() {
    if (metrics) {
        storage.set({key: LOCAL_STORAGE_NAME, metrics, url: getUrl()})
    }
}

function loop(timestamp) {
    if (lastFrameTime === 0) {
        lastFrameTime = timestamp
    }
    const eachFrameTime = timestamp - lastFrameTime

    timeList.push(eachFrameTime)

    //FIXME 最后一次不满100的数据会被丢弃
    if (timeList.length === N) {
        const X = timeList.splice(0, N).sort()
        digest.push(X)
        digest.compress()

        metrics = {
            // average: getThreeDecimals(X.reduce((arr, cur) => arr + cur, 0) / N),
            frame_50: getThreeDecimals(digest.percentile(0.5)),
            frame_90: getThreeDecimals(digest.percentile(0.9)),
            frame_95: getThreeDecimals(digest.percentile(0.95)),
            frame_99: getThreeDecimals(digest.percentile(0.99)),
            // slow_percent: getThreeDecimals(X.filter(cur => cur > SLOW_FLAG).length / N),
            // freeze_precent: getThreeDecimals(X.filter(cur => cur > FREEZE_FLAG).length / N),
        }
    }

    lastFrameTime = timestamp
    window.requestAnimationFrame(loop)

    // 标记统计成功
    return true
}

function checkLocalStorageData() {
    const storageDataStr = storage.get({key: LOCAL_STORAGE_NAME})

    if (storageDataStr) {
        const data = JSON.parse(storageDataStr)
        record(data)
        storage.clear({key: LOCAL_STORAGE_NAME})
    }

    //路由切换是可以拿到当前页面的数据
    if (metrics) {
        // storage.set({key: LOCAL_STORAGE_NAME, metrics, pathname: window.location.pathname})
        record({ metrics })
    }
}

function record({ metrics, url }) {
    let pathname;
    if (url) {
        pathname = urlParse(url).pathname;
    }
    transport({
        endPoints: [FIREBASE_ENDPOINT_NAME, PROMETHEUS_ENDPOINT_NAME],
        type: 'frame',
        url,
        traceName: `frame_${getRouteName(pathname)}`,
        message: {
            metrics: {
                duration: metrics.frame_50,
                ..._.pick(metrics, ['frame_90', 'frame_95', 'frame_99']),
            },
            attributes: {
                device_level: getDeviceLevel(),
            },
        },
    });
}
